import { topicGroups } from "@/mocks/home";

export default function TopicWall() {
  return (
    <section id="topics" className="bg-background-50 py-16 md:py-24">
      <div className="shell">
        <div className="flex flex-col gap-4 border-l-2 border-primary-500 pl-4 md:pl-5">
          <span className="text-xs font-semibold tracking-[0.2em] text-primary-600">
            TOPIC WALL · 话题墙
          </span>
          <h2 className="font-serif text-2xl font-bold text-foreground-950 md:text-3xl">
            今晚围什么，先看看热榜
          </h2>
          <p className="max-w-xl text-sm leading-relaxed text-foreground-600">
            按现场类型归类的最新话题，热度跟随围观人数实时浮动。挑一个顺眼的瓜点，
            点进去就是第一现场。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:mt-14 md:grid-cols-2">
          {topicGroups.map((g) => (
            <div
              key={g.id}
              className="rounded-lg border border-background-200/70 bg-background-50 p-5 transition-colors hover:border-primary-200 md:p-6"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2.5">
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className={g.icon}></i>
                  </span>
                  <h3 className="text-sm font-bold text-foreground-950 md:text-base">
                    {g.label}
                  </h3>
                </div>
                <span className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  {g.topics.length} 个进行中
                </span>
              </div>

              <div className="mt-4 flex flex-wrap gap-2">
                {g.topics.map((t) => (
                  <a
                    key={t.name}
                    href="#scene"
                    className="group inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border border-background-200 bg-background-100 px-3 py-1.5 text-xs text-foreground-800 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
                  >
                    <span>{t.name}</span>
                    <span className="flex items-center gap-0.5 text-[11px] text-accent-600 group-hover:text-primary-600">
                      {t.rise > 0 ? <i className="ri-arrow-up-line text-[10px]"></i> : null}
                      {t.heat}
                    </span>
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 flex items-center justify-center">
          <a
            href="#scene"
            className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-sm text-primary-600 transition-colors hover:text-primary-700"
          >
            进入话题现场围观
            <i className="ri-arrow-right-down-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}